<template>
    <div>
        <Loader ref="Loader"></Loader>
        <SuccessModal ref="successModal"></SuccessModal>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <YesNoModal ref="YesNoModal" />
        <v-flex xs12>
            <v-card>
                <v-toolbar color="secondary" dark dense>
                    <v-toolbar-title>Inspection Templates</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn fab small color="success">
                        <v-icon @click="InspectionTemplateDialog = true"
                            v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')">add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-list>
                    <v-list-group v-for="item in InspectionTemplateData" :key="item.InspectionTemplate.ID"
                        :prepend-icon="item.action" no-action expand>
                        <template slot="activator">
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ item.InspectionTemplate.Name }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-btn small fab color="primary" @click="deleteInspection(item)"
                                    v-if="HasAccess('INSPECTION_MANAGEMENT', 'DELETE')">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-list-tile>
                        </template>
                        <v-list-tile v-for="subItem in item.InspectionTemplateItems" :key="subItem.ID" @click="1==1"
                            style="width: 100%">
                            <v-list-tile-content>z
                                <v-text-field v-model="subItem.Name" style="width: 80%"></v-text-field>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-layout row wrap>
                                    <v-flex ma-1>
                                        <v-btn fab small color="success" @click="saveItem(subItem)"
                                            v-if="HasAccess('INSPECTION_MANAGEMENT', 'MODIFY')">
                                            <v-icon>save</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex ma-1>
                                        <v-btn fab small ma-1 color="primary" @click="deleteItem(subItem)"
                                            v-if="HasAccess('INSPECTION_MANAGEMENT', 'DELETE')">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-layout justify-end>
                            <v-flex class="text-xs-right" shrink>
                                <v-btn small color="success" @click="ShowItemCreateDialog(item)"
                                    v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')">Add item</v-btn>
                                <v-btn small color="primary" @click="ShowItemPoolDialog(item)"
                                    v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')">Select
                                    from pool</v-btn>
                                <v-btn small outline color="blue" v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')"
                                    @click="OpenAddToCustomerGroupDialog(item)">Add To Customer Group</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-list-group>
                </v-list>
            </v-card>
        </v-flex>
        <!-- DIALOG FOR INSPETION TEMPLATE CREATE -->
        <v-dialog v-model="InspectionTemplateDialog" width="600px" offset-x persistent>
            <v-form ref="jobGroupCreationDialog" @submit.prevent>
                <v-card>
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>Create New Inspection Template</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="InspectionTemplateDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-layout row wrap ma-4>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <v-text-field v-model="InspectionTemplateForm.Name" :rules="fieldRules"
                                label="Inspection Template Name">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary" @click="AddInspectionTemplate()"
                                :disabled="InspectionTemplateForm.Name == null">
                                Create
                            </v-btn>
                            <v-btn flat @click="InspectionTemplateDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- INSPECTION TEMPLATE ITEM CREATION -->
        <v-dialog v-model="InspectionItemsDialog" width="700px" offset-x persistent>
            <v-form @submit.prevent>
                <v-card>
                    <v-toolbar color="secondary" dark dense>
                        <v-toolbar-title>Create New Inspection Item</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="InspectionItemsDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-layout row ma-4>
                        <v-flex xs12>
                            <v-text-field v-model="InspectionItemForm.Name" label="Name">
                            </v-text-field>
                            <v-textarea box v-model="InspectionItemForm.Comments" label="Description">
                            </v-textarea>
                        </v-flex>
                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary"
                                :disabled="InspectionItemForm.Name == null || InspectionItemForm.Name.length == 0"
                                @click="AddInspectionItem()">
                                Create
                            </v-btn>
                            <v-btn flat @click="InspectionItemsDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- ITEM POOL -->
        <v-dialog v-model="ItemPoolDialog" width="600px" offset-x persistent>
            <v-form @submit.prevent="AddItemPool">
                <v-card>
                    <v-toolbar color="secondary" dark dense>
                        <v-toolbar-title>Select From Item Pool</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="ItemPoolDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-layout row wrap ma-4 v-for="(item, index) in PoolItems" :key="index">
                            <v-flex xs4 sm4 md4 lg4 xl4>
                                <v-checkbox :label="item.Name" v-model="item.selectedItemsFromPool"
                                    @change="checkSelectedItems(item)"></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary">
                                Add
                            </v-btn>
                            <v-btn flat @click="ItemPoolDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="AddToCustGroupDialog" width="700px" persistent>
            <v-form ref='CustomerGroupForm' @submit.prevent="AddInspectionToGroup">
                <v-card>
                    <v-toolbar color="secondary" dark dense>
                        <v-toolbar-title>Add Inspection To Customer Group</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="AddToCustGroupDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-layout row wrap ma-2>
                            <v-combobox multiple label="Search for customer" v-model="SelectedCustomers"
                                :items="CustomerList" item-text="Name" item-value="ID" chips></v-combobox>
                        </v-layout>
                    </v-flex>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary" :disabled="SelectedCustomers.length == 0">
                                Add
                            </v-btn>
                            <v-btn flat @click="AddToCustGroupDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                SelectedCustomer: null,
                SelectedCustomers: [],
                InspectionToAdd: null,
                CustomerList: [],
                AddToCustGroupDialog: false,
                LastOpenList: null,
                InspectionTemplateDialog: false,
                InspectionItemsDialog: false,
                ItemPoolDialog: false,
                InspectionTemplateForm: {
                    Name: null
                },
                InspectionItemForm: {
                    InspectionTemplateID: 0,
                    Name: null,
                    Comments: null
                },
                // InspectionItemPoolForm: [{
                //     InspectionTemplateID: 0,
                //     Name: null,
                //     Comments: null
                // }],
                InspectionItemPoolForm: [],
                TemplateID: 0,
                selectedItemsFromPool: [],
                InspectionTemplateData: [],
                fieldRules: [v => !!v || "Field is required"],
                PoolItems: []
            }
        },
        mounted() {
            let self = this;

            self.FetchInspectionTemplateData();
            self.FetchInspectionItemPool();
            self.GetCustomers();
        },
        methods: {
            GetCustomers() {
                let self = this;

                self.get(`Customer`)
                    .then(response => {
                        self.CustomerList = response.data;
                    })
                    .catch(error => {
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(error.toString());
                    });
            },
            AddInspectionToGroup() {
                let self = this;

                console.log("[SELECTED CUSTOMERS]", self.SelectedCustomers)
                console.log("[INSPECTION TO ADD]", self.InspectionToAdd)
                let Request = {
                    CustomerList: self.SelectedCustomers,
                    Inspection: self.InspectionToAdd
                }

                self.post(`InspectionTemplate/PosttemplateToCustomerGroup`, Request).then(r => {
                    console.log(r.data)
                    if(r.data == true) {
                        self.AddToCustGroupDialog = false;
                        self.$refs.successModal.setText('Successfully posted template to customer(s)!');
                        self.$refs.successModal.show();
                    } 
                })
            },
            FetchInspectionTemplateData() {
                let self = this;

                self.get('InspectionTemplate/Complex').then(r => {
                    console.log("INSPECTION TEMPLATE WITH ITEMS", r.data)

                    self.InspectionTemplateData = r.data;
                })
            },
            FetchInspectionItemPool() {
                let self = this;

                self.get(`InspectionTemplateItems/GetPool`).then(r => {
                    console.log("[ITEM POOL]", r.data)
                    self.PoolItems = r.data;
                })
            },
            checkSelectedItems(item) {
                let self = this;

                self.$nextTick(() => {
                    console.log(item);
                    //self.selectedItemsFromPool.push(item.Name);
                    self.InspectionItemPoolForm.push({
                        InspectionTemplateID: self.TemplateID,
                        Name: item.Name,
                        Comments: ""
                    })
                    console.log("POOL FORM", self.InspectionItemPoolForm)
                })

                console.log("[SELECTED ITEMS]", self.selectedItemsFromPool)
            },
            AddInspectionTemplate() {
                let self = this;
                let Request = self.InspectionTemplateForm;
                self.post('InspectionTemplate', Request).then(r => {
                    console.log("Inspection Template created", r.data)
                    self.FetchInspectionTemplateData();

                    self.InspectionTemplateForm.Name = null;
                    self.InspectionTemplateDialog = false;
                })
            },
            ShowItemCreateDialog(item) {
                let self = this;
                console.log(item)

                self.InspectionItemForm.InspectionTemplateID = item.InspectionTemplate.ID;
                self.InspectionItemsDialog = true;
            },
            ShowItemPoolDialog(item) {
                let self = this;
                console.log("[INSPECTION TEMPLATE]", item)
                self.TemplateID = item.InspectionTemplate.ID;
                self.ItemPoolDialog = true;
            },
            AddInspectionItem() {
                let self = this;
                let Request = self.InspectionItemForm;

                self.post('InspectionTemplateItems', Request).then(r => {
                    self.FetchInspectionTemplateData();
                    self.InspectionItemsDialog = false;
                    self.InspectionItemForm = {
                        Name: null,
                    };
                    self.FetchInspectionItemPool();
                })
            },
            AddItemPool() {
                let self = this;

                let Request = self.InspectionItemPoolForm;
                console.log("[REQUEST]", Request)

                self.post(`InspectionTemplateItems/PostMultiple`, Request).then(r => {
                    console.log("posted pool", r.data)
                    self.FetchInspectionTemplateData();
                    self.FetchInspectionItemPool();
                    self.ItemPoolDialog = false;
                    self.InspectionItemPoolForm = []
                    self.TemplateID = 0;
                    self.selectedItemsFromPool = [];
                })
            },
            OpenAddToCustomerGroupDialog(item) {
                let self = this;

                self.$refs.CustomerGroupForm.reset();
                console.log("[ITEM]", item)
                self.InspectionToAdd = item;
                self.AddToCustGroupDialog = true;
            },
            deleteItem(item) {
                let self = this;
                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this inspection item?",
                    function (yes) {
                        if (yes == true) {
                            self.delete(`InspectionTemplateItems?id=${item.ID}`).then(result => {
                                    self.FetchInspectionTemplateData();
                                    self.$refs.successModal.setText('Successfully deleted.');
                                    self.$refs.successModal.show(true);
                                    setTimeout(() => {
                                        self.$refs.successModal.hide();
                                    }, 1500);
                                })
                                .catch(error => {
                                    console.warn("[SAVE] Failed to save the item", error.toString());
                                })
                        }
                    })
            },
            deleteInspection(item) {
                let self = this;

                console.log("delete inspection", item)

                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this inspection? Customer inspections with this inspection will not be deleted.",
                    function (yes) {
                        if (yes == true) {
                            self.delete(
                                    `InspectionTemplate/DeleteInspectionWithItems?id=${item.InspectionTemplate.ID}`)
                                .then(result => {
                                    self.FetchInspectionTemplateData();
                                    self.$refs.successModal.setText('Successfully deleted.');
                                    self.$refs.successModal.show(true);
                                    setTimeout(() => {
                                        self.$refs.successModal.hide();
                                    }, 1500);
                                })
                                .catch(error => {
                                    console.warn("[SAVE] Failed to delete the item", error.toString());
                                })
                        }
                    })
            },
            saveItem(item) {
                let self = this;

                self.put(`InspectionTemplateItems?id=${item.ID}`, item).then(result => {
                        self.$refs.successModal.setText('Successfully saved.');
                        self.$refs.successModal.show(true);
                        setTimeout(() => {
                            self.$refs.successModal.hide();
                        }, 1500);
                    })
                    .catch(error => {
                        console.warn("[SAVE] Failed to save the item", error.toString());
                    })
            }
        }
    }
</script>

<style>

</style>